import { cloneDeep } from "lodash";
export var addPoll = function (polls, poll) {
    if (!poll) {
        return polls;
    }
    var clonedItem = cloneDeep(polls);
    var clonedComment = cloneDeep(poll);
    clonedItem.results.unshift(clonedComment);
    return clonedItem;
};
export var deletePoll = function (polls, poll) {
    if (!poll) {
        return polls;
    }
    var index = polls.results.findIndex(function (c) { return c.uuid === poll.uuid; });
    if (index < 0) {
        return polls;
    }
    var clonedPolls = cloneDeep(polls);
    clonedPolls.results = clonedPolls.results.filter(function (c) { return c.uuid !== poll.uuid; });
    return clonedPolls;
};
